import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { BaseCell } from "@similarweb/pro-logic-components";
import { IconButton } from "@similarweb/ui-components";

export const StyledSocialNetworkIconButton = styled(IconButton)`
    ${SWReactIcons} {
        svg path {
            fill: ${({ iconColor }) => iconColor} !important;
        }
    }
`;

export const StyledBaseCell = styled(BaseCell)<{ isCentered: boolean }>`
    ${({ isCentered }) =>
        isCentered &&
        css`
            display: flex;
            align-items: center;
            justify-content: center;
        `}
`;
